// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTimer_container__x2tyX","label":"EventTimer_label__25ErP","countdown":"EventTimer_countdown__2XNsx","hideButton":"EventTimer_hideButton__1WNHQ"};